import { getMessageHtmlElem } from 'utils/message';
import { getIsWaitingForAdvocateScenario } from '../../utils/getAndSetIsForcedSystemTypingAnimation';

import { isDebugMode } from 'utils/debug';
import { FormattedMessagesType } from '../types';
import { IRefObserver } from './types';

/**
 * Clear observables from previous latest messages. Will be replaced by new observable with updated indexes.
 */
export const stopAllScrollObservers = (reactRef: IRefObserver, msgCount: number) => {
  const elemMsgThirdLast = getMessageHtmlElem.byIndex(msgCount - 2 - 1);
  const elemMsgSecondLast = getMessageHtmlElem.byIndex(msgCount - 1 - 1);
  const elemMsgLast = getMessageHtmlElem.byIndex(msgCount - 1);

  if (isDebugMode()) {
    if (elemMsgThirdLast) elemMsgThirdLast.style.backgroundColor = 'transparent';
    if (elemMsgSecondLast) elemMsgSecondLast.style.backgroundColor = 'navy';
    if (elemMsgLast) elemMsgLast.style.backgroundColor = 'orange';
  }

  if (reactRef.current) {
    elemMsgThirdLast && reactRef.current.unobserve(elemMsgThirdLast);
    elemMsgSecondLast && reactRef.current.unobserve(elemMsgSecondLast);
    elemMsgLast && reactRef.current.unobserve(elemMsgLast);
    reactRef.current = null;
  }
};

export const isElemScrolledToBottom = (elem: HTMLElement | null, pxTolerance = 0): boolean => {
  if (!elem) return false;
  const case1 = pxTolerance
    ? elem.scrollTop + pxTolerance >= elem.scrollHeight - elem.offsetHeight
    : elem.scrollTop == elem.scrollHeight - elem.offsetHeight;
  const case2 = elem.scrollHeight - elem.scrollTop - elem.clientHeight - pxTolerance < 1;
  return case1 || case2;
};

export const isScrollToBottomMsgEdgeCase = (msg: FormattedMessagesType): boolean => {
  if (!msg) return false;
  const isMsgAvatarUpdate =
    Boolean(msg?.extension?.messageBodies?.list[0]?.extension?.avatarUpdate) ||
    Boolean(msg?.extension?.avatarUpdate);
  const isMsgForm = Boolean(msg?.extension?.form);
  const isConnectingToAdvocate = getIsWaitingForAdvocateScenario(msg);
  return isMsgAvatarUpdate || isMsgForm || isConnectingToAdvocate;
};
